import React from 'react';
import '../template-file-css/document-file-template.css';


export const LaGeneral_SafetyPlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='LaGeneral_SafetyPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>MST Safety Plan</h3></center>
                </p>

                <p className='w-750'> <span className='eleHeader'>1. Risk Assessment: </span>
                    <input type='text' id='txtRiskAssessment' name='txtRiskAssessment' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>A. Safety Issues:</span> </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSuicide' name='cbSuicide' className='add-only' value='Suicide' /> Suicide </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSelfHarm' name='cbSelfHarm' className='add-only' value='Self- Harm' /> Self- Harm </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicalAggression' name='cbPhysicalAggression' className='add-only' value='Physical Aggression' /> Physical Aggression </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSexualActingOut' name='cbSexualActingOut' className='add-only' value='Sexual Acting Out' /> Sexual Acting Out  </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFireSetting' name='cbFireSetting' className='add-only' value='Fire Setting' /> Fire Setting </td>
                    </tr>
                </table>

                <p className='w-750'><b>B. Describe the Intensity/Frequency/Duration/Systems Impact of this Behavior:</b></p>

                <table>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'>Behavior</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Frequency</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Intensity</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Duration</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Systems</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtBehavior' name='txtBehavior' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtFrequency' name='txtFrequency' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtIntensity' name='txtIntensity' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDuration' name='txtDuration' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtSystems' name='txtSystems' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>C. Identify Triggers and Sequences:</b>
                </p>

                <p className='w-750'> <span className='eleHeader'>Triggers:</span>
                    <textarea id='txtTriggers' name='txtTriggers' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Sequence:</span>
                    <textarea id='txtSequence' name='txtSequence' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>{`D. Complete the “MST Fit” (Domains: Individual, Family, Community, Peers, and School)`}</b>
                </p>

                <p className='w-750'> <span className='eleHeader'>Behavior:</span>
                    <textarea id='txtBehavior' name='txtBehavior' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Drivers</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Domains:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDrivers_1' name='txtDrivers_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDomains_1' name='txtDomains_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDrivers_2' name='txtDrivers_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDomains_2' name='txtDomains_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDrivers_3' name='txtDrivers_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDomains_3' name='txtDomains_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDrivers_4' name='txtDrivers_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDomains_4' name='txtDomains_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDrivers_5' name='txtDrivers_5' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDomains_5' name='txtDomains_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDrivers_6' name='txtDrivers_6' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDomains_6' name='txtDomains_6' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Priority Driver:</span>
                    <textarea id='txtPriorityDriver' name='txtPriorityDriver' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Secondary Driver:</span>
                    <textarea id='txtSecondaryDriver' name='txtSecondaryDriver' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>2. Outline the Plan of Action:</b>{`Based on the Risk Assessment identify behavioral and cognitive changes family members/support people will do to reduce the harmful behavior:`}
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>IF...</span> </td>
                        <td className='w-375'> <span className='eleHeader'>THEN...</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOutlineThePlan_1' name='txtOutlineThePlan_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtThen_1' name='txtThen_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOutlineThePlan_2' name='txtOutlineThePlan_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtThen_2' name='txtThen_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOutlineThePlan_3' name='txtOutlineThePlan_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtThen_3' name='txtThen_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOutlineThePlan_4' name='txtOutlineThePlan_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtThen_4' name='txtThen_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOutlineThePlan_5' name='txtOutlineThePlan_5' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtThen_5' name='txtThen_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOutlineThePlan_6' name='txtOutlineThePlan_6' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtThen_6' name='txtThen_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOutlineThePlan_7' name='txtOutlineThePlan_7' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtThen_7' name='txtThen_7' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>Plan for Supports:</b>{`(Who, When, and Where will supports be utilized)`}
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Identified Supports</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone #</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Duties</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Times</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Places</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtIdentifiedSupports_1' name='txtIdentifiedSupports_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPhoneNumber_1' name='txtPhoneNumber_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDuties_1' name='txtDuties_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='time' id='txtTimes_1' name='txtTimes_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPlaces_1' name='txtPlaces_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtIdentifiedSupports_2' name='txtIdentifiedSupports_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPhoneNumber_2' name='txtPhoneNumber_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtDuties_2' name='txtDuties_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='time' id='txtTimes_2' name='txtTimes_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPlaces_2' name='txtPlaces_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>{`3. Communication Plan for everyone with a Role in the Safety/Monitoring Plan:`}</b>
                </p>

                <p className='w-750'><b>A. Therapist will contact the family:</b>{`(How often, under what conditions, and by what means) Therapist will contact family and follow-up with plan at least 2-3 times a week.`}
                </p>

                <p className='w-750'><b>C. Plans for other supports:</b>{`(Who, when, where and by what means will support be utilized)`}
                </p>

                <p className='w-750'>
                    <ol>
                        <li>
                            {`Plan will run for 14 days, and will be reviewed/revised by the family, identified supports, the MST therapist, MST Supervisor and MST Consultant.`}
                        </li>
                        <li>
                            Safety Plan will be complete after 30 days with no harmful behaviors being display.
                        </li>
                    </ol>
                </p>

                <p className='w-750'><b>4. Signatures & date: </b>All key participants should sign off on the plan as a commitment to assist this family to success.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}  
